import { Component, inject, input } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NotifyService } from '@fry/lib/utils';

@Component({
    selector: 'rsr-button-copy-to-clipboard',
    templateUrl: './copy-button.component.html',
    styleUrls: ['./copy-button.component.css'],
    imports: [MatButton, MatIconButton, MatIcon],
    standalone: true
})
export class CopyButton {
  text = input('');
  title = input($localize `Copy to clipboard`);
  hideTitle = input(false);

  private notify = inject(NotifyService);

  public copy() {
    if (this.text().length > 0) {
      navigator.clipboard.writeText(this.text()).then(() => {
        this.notify.success($localize `Copied to clipboard`);
      });
    }
  }
}
